export default __webpack_public_path__ + "static/media/sf2.76a5d082.svg";